import { SubmitCategoryInput, SubmitCategoryResponse } from '@/models/gen/graphql';

import { SubmitCategoryDocument } from '@/api/queries';
import graphApi from '@/api';

const [_, runSubmitCategory] = graphApi(SubmitCategoryDocument);

export const submitCategory = async (questionnaireAttemptCategorySnapshotId: string): Promise<SubmitCategoryResponse> => {
  if (!questionnaireAttemptCategorySnapshotId) throw new Error('submitCategory: no category snapshot id provided');

  const input: SubmitCategoryInput = { questionnaireAttemptCategorySnapshotId };
  const res = await runSubmitCategory({ input });

  return res?.submitCategory;
};
